import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Layout from "./components/Layout/Layout";

import "bootstrap/dist/css/bootstrap.min.css";
function App() {
  return <Layout />;
}

export default App;
